import { render } from "./plant.vue?vue&type=template&id=6075658c&scoped=true"
import script from "./plant.vue?vue&type=script&lang=js"
export * from "./plant.vue?vue&type=script&lang=js"

import "./plant.vue?vue&type=style&index=0&id=6075658c&lang=less&scoped=true"

import exportComponent from "E:\\a工互\\vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6075658c"]])

export default __exports__